import React from 'react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import { fetchConToken } from 'helpers/fetch';
import { getDataSession } from 'views/Utils/Common';

export function sucursalActual() {
    return getDataSession('sucursal');
}

export function mensajeError(response) {
    if (!response || typeof response !== 'object' || Array.isArray(response)) return null;

    if (response.status && Number(response.status) >= 400) {
        if (response.errors) return Object.values(response.errors).flat()[0] || 'Error';

        return response.title || 'Error';
    }

    if (response.codigo && Number(response.codigo) >= 400) return response.mensajes?.[0] || 'Error';

    return null;
}

export function avisarError(response) {
    const mensaje = mensajeError(response);
    if (!mensaje) return false;

    Swal.fire('Error', mensaje, 'error');
    return true;
}

export async function cargar(url) {
    const response = await fetchConToken(url);
    if (avisarError(response)) return [];

    if (Array.isArray(response)) return response;

    return response?.data || [];
}

export function tokenOperacion(prefijo) {
    return `${prefijo}-${Date.now()}`;
}

export function siNo(valor) {
    return valor === 'S' || valor === true ? 'Si' : 'No';
}

export function nombreTipoDocto(tipo) {
    return { O: 'Orden', V: 'Venta', D: 'Devolucion', P: 'Cobro CxC' }[tipo] || tipo || '';
}

export function nombreEstatus(estatus) {
    return { P: 'Pendiente', S: 'Surtida', C: 'Cancelada', N: 'Normal', A: 'Activo', I: 'Inactivo' }[estatus] || estatus || '';
}

export function nombreTipoCobro(tipo) {
    return { E: 'Efectivo', C: 'Cheque', T: 'Tarjeta', O: 'Otro', R: 'Credito' }[tipo] || tipo || '';
}

export function dinero(valor) {
    const numero = Number(valor || 0);
    return numero.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function BotonNuevo({ to, children }) {
    return (<Link to={to} className='btn btn-outline-primary'>
        <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' fill='currentColor' className='bi bi-plus-square' viewBox='0 0 16 16'>
            <path d='M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z' />
            <path d='M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z' />
        </svg>
        &nbsp; {children || 'Nuevo'}
    </Link>);
}

export function BotonesForma({ isAddMode, extra, regresar }) {
    return (<div className='col-md-12' style={{ textAlign: 'right' }}>
        <button className='btn btn-outline-success' type='submit'>
            <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' fill='currentColor' className='bi bi-check-lg' viewBox='0 0 16 16'>
                <path d='M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z' />
            </svg>
            &nbsp; Guardar
        </button>
        &nbsp;{extra}
        <Link to={regresar || (isAddMode ? '.' : '..')} className='btn btn-outline-warning'>
            <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' fill='currentColor' className='bi bi-reply' viewBox='0 0 16 16'>
                <path d='M6.598 5.013a.144.144 0 0 1 .202.134V6.3a.5.5 0 0 0 .5.5c.667 0 2.013.005 3.3.822.984.624 1.99 1.76 2.595 3.876-1.02-.983-2.185-1.516-3.205-1.799a8.74 8.74 0 0 0-1.921-.306 7.404 7.404 0 0 0-.798.008h-.013l-.005.001h-.001L7.3 9.9l-.05-.498a.5.5 0 0 0-.45.498v1.153c0 .108-.11.176-.202.134L2.614 8.254a.503.503 0 0 0-.042-.028.147.147 0 0 1 0-.252.499.499 0 0 0 .042-.028l3.984-2.933zM7.8 10.386c.068 0 .143.003.223.006.434.02 1.034.086 1.7.271 1.326.368 2.896 1.202 3.94 3.08a.5.5 0 0 0 .933-.305c-.464-3.71-1.886-5.662-3.46-6.66-1.245-.79-2.527-.942-3.336-.971v-.66a1.144 1.144 0 0 0-1.767-.96l-3.994 2.94a1.147 1.147 0 0 0 0 1.946l3.994 2.94a1.144 1.144 0 0 0 1.767-.96v-.667z' />
            </svg>
            &nbsp; Regresar &nbsp;
        </Link>
    </div>);
}

export function SwitchSN({ name, label, checked, onChange }) {
    return (<div className='form-check form-switch margin_left_switch'>
        <input type='checkbox' className='form-check-input' name={name} role='switch' onChange={onChange} checked={checked === 'S'} />
        <label htmlFor={name} className='margin_left_switch margin_top_switch_label'>{label}</label>
    </div>);
}

export function Campo({ label, children }) {
    return (<div className='mb-2'>
        <label className='form-label'>{label}</label>
        {children}
    </div>);
}

export function Tarjeta({ titulo, children }) {
    return (<div className='card mb-3'>
        {titulo ? <div className='card-header'><label className='form-label title'>{titulo}</label></div> : ''}
        <div className='card-body text-start'>
            {children}
        </div>
    </div>);
}
